import { v4 as uuidv4 } from "uuid";
/**
 * @description 파일명에 접두어를 추가합니다.
 * @param originFileName 원본 파일명 abc.jpg
 * @returns { string } - 접두어가 추가된 파일명 / 예: abc_2023-10-05T12:34:56.789Z_a1b2c3d4.jpg
 */
export function addPrefixToFileName(originFileName) {
    const fileNameArr = originFileName.split("."); // 파일명을 '.' 기준으로 분리
    const fileExt = fileNameArr.pop(); // 파일 확장자 분리
    const base = fileNameArr.join(""); // 확장자를 제외한 파일명
    return `${base}_${new Date().toISOString()}_${uuidv4().slice(8)}.${fileExt}`;
}
/**
 * @description 파일명에서 를 추출합니다.
 *
 * @param {string | null} fileName 접두사가 포함된 파일 이름 / 예: "path/abc_2023-10-05T12:34:56.789Z_a1b2c3d4.jpg"
 * @returns {string} - 원본 파일 이름
 */
export function extractOriginalName(key) {
    if (!key) {
        return "";
    }
    const fileName = key.split("/").pop() || ""; // 경로에서 파일명만 가져오기
    const fileNameArr = fileName.split("."); // 파일명을 '.' 기준으로 분리
    const fileExt = fileNameArr.pop(); // 파일 확장자 분리
    const base = fileNameArr.join(""); // 확장자를 제외한 파일명 합치기
    const splitBase = base.split("_");
    splitBase.pop(); // uuid 제거
    splitBase.pop(); // timestamp 제거
    return splitBase.join("_") + (fileExt ? `.${fileExt}` : "");
}
